import React, { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import moon from "../../assets/svg/moon.svg";
import sun from "../../assets/svg/sun.svg";
import logoutIcon from "../../assets/svg/logout.svg";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import {
   getAppearance,
   setAppearance,
   subscribeAppearance,
} from "../../utils/appearanceSettings";

function DarkModeToggle() {
   const navigate = useNavigate();

   // tema stă în setările de aspect (aceeași și în fereastra „Setări”)
   const [theme, setTheme] = useState(() => getAppearance().theme);
   useEffect(() => subscribeAppearance((next) => setTheme(next.theme)), []);

   const toggleDarkMode = () => {
      setAppearance({ theme: theme === "light" ? "dark" : "light" });
   };
   const handleLogout = () => {
      Cookies.remove("access_token"); // șterge cookie-ul
      //localStorage.clear(); // curăță stocarea locală
      sessionStorage.clear(); // curăță sesiunea
      navigate("/"); // redirecționează spre login
   };
   return (
      <>
         <li className="settings__item">
            <button
               className="settings__mode-btn"
               id="light-mode-toggle"
               onClick={toggleDarkMode} // Toggle to dark mode
            >
               <div className="settings__icons">
                  <ReactSVG
                     className="settings__icon settings__light"
                     src={sun}
                  />
                  <ReactSVG
                     className="settings__icon settings__dark"
                     src={moon}
                  />
               </div>
            </button>
         </li>
         <li className="settings__item">
            <button onClick={handleLogout} className="settings__mode-btn ">
               <div className="settings__icons">
                  <ReactSVG
                     className="settings__icon-logout"
                     src={logoutIcon}
                  />
               </div>
            </button>
         </li>
      </>
   );
}

export default DarkModeToggle;
